import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import moment from 'moment-timezone';
import RoomsContainer from './Reservation/RoomContainer.js';
import { MENU } from '../Sidebar.js';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

let cancelToken;
let state;
let tokenSession;

class StoreContainer extends Component {

    getInitState = () => {
        return {
            centerId: "",
            center: null,
            centerQuery: "",
            centers: [],
            date: "",
            duration: "",
            durations: [],
            isTomorrow: "",
            isSearching: false,
            reservationId: "",
            room: null,
            rooms: [],
            search: null,
            time: "08:00",
        };
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }

        if (props.center) {
            state.center = props.center;
            state.centerQuery = props.centerQuery;
            state.centers = props.centers;
        }

        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();

        this.getProfile({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    getProfile = (params) => {
        this.props.post(
            "/getProfileUser",
            params,
            (response) => this.didGetProfile(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetProfile = (response) => {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.props.user.balance = response.balance;
        this.props.user.credits = response.credits;
        this.setState({
            isTomorrow: moment(tomorrow),
            center: response.center,
            date: moment(tomorrow, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            centerQuery: response.center_name,
            empresa_id: response.empresa_id
        })
    }

    getCenters = (params) => {
        this.props.post(
            "/getCenters",
            params,
            (response) => this.didGetCenters(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetCenters = (response) => {
        this.setState({ centers: response });
        this.handleOptionUpdate();
    }

    handleOptionUpdate = () => {
        if ($("#center-results").children().length) {
            $("#center-results").css("display", "");
        } else {
            $("#center-results").css("display", "none");
        }
    }

    handleCenterClick = (center) => {
        this.setState({
            center: center,
            centerQuery: center.name
        });
    }

    renderCenter = (center, index) => {
        return (
            <li key={index}>
                <a onClick={() => this.handleCenterClick(center)}>
                    {center.name}
                </a>
            </li>
        );
    }

    handleIsSala = (params) => {
        this.setState({
            is_Sala: true,
        });
    }

    handleIsCowork = (params) => {
        this.setState({
            is_Cowork: true,
        });
    }

    handleCenterSearch = (event) => {
        const getCenters = () => this.getCenters({
            query: this.state.centerQuery,
            token_id: this.props.getTokenId()
        });

        this.setState({
            center: null,
            centerQuery: event.target.value
        }, getCenters);
    }

    renderSalasContainer = () => {
        return (
            <RoomsContainer
                center={this.state.center}
                centerQuery={this.state.centerQuery}
                centers={this.state.centers}
                getTokenId={this.props.getTokenId}
                getTokenSession={this.props.getTokenSession}
                handleErrorResponse={this.props.handleErrorResponse}
                post={this.props.post}
                postStore={this.props.postStore}
                user={this.state.user} />
        )
    }

    renderSelectCoworkorSala = () => {
        const { t } = this.props;
        return (
            <div className="container-fluid container-padding text-center container-desktop">
                <div className="row">
                    <div className="col-xs-8 col-xs-offset-2 col-sm-10 col-sm-offset-1">
                        <div className="col-md-6">
                            <button


                                onClick={() => alert("No Disponible en este momento!")}
                            >
                                <img alt={t('guest.store.img_calendar')} className="icon-accent" src={''} />
                                <h4 className="text-primary text-heding">COWORK HÍBRIDO</h4>
                                <p className="text-primary text-container">Espacios de trabajo en áreas comunes con acceso flexible por horas, día, mes o si lo prefieres ilimitado.</p>
                                <p className="text-primary text-container">Inicia desde $15 USD por día</p>
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button
                                onClick={() => this.handleIsSala()}
                            >
                                <img alt={t('guest.store.img_calendar')} className="icon-accent" src={''} />
                                <h4 className="text-primary text-heding">SALAS DE JUNTAS Y VIDEO CONFERENCIAS</h4>
                                <p className="text-primary text-container">Salas de juntas totalmente equipadas en renta por hora, día o mes desde 1 a 30 personas</p>
                                <p className="text-primary text-container">Inicia desde $15 USD por día</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { t } = this.props;

        return (
            <div className="content-resvations">
                <div className="container-benefits-title">
                </div>
                <div>
                    {!this.state.is_Cowork && !this.state.is_Sala ? this.renderSelectCoworkorSala() : null}
                    {this.state.is_Sala ? this.renderSalasContainer() : null}
                </div>
            </div>
        );
    }
}

export default translate('common')(StoreContainer);


// WEBPACK FOOTER //
// ./src/dashboard/store/StoreContainer.js